<section class="g-brd-bottom g-brd-gray-light-v4 g-py-30 breadcrumbs">
   <div class="container">
       <ul class="d-flex justify-content-between u-list-inline">
           <li class="list-inline-item g-mr-15">
               <a class="u-link-v5 g-color-text g-pr-10" routerLink="/">Home</a>
               <i class="g-color-gray-light-v2 g-ml-5 fa fa-angle-right"></i>
           </li>
           <li class="list-inline-item g-color-primary">
               <span>Events</span>
           </li>
           <li class="list-inline-item ml-auto"></li>
       </ul>
   </div>
</section>

<div class="container g-pt-100 g-pb-70" style="margin-top: -50px">
   <!-- Heading -->
   <div class="g-max-width-550 text-center mx-auto g-mb-70">
       <h1 class="h3 mb-5">
           <p class="g-font-weight-600">Events</p>
       </h1>
   </div>
   <!-- End Heading -->

   <div class="row">
       <!-- FIRST TWO EVENTS - New Style Cards -->
       
       <!-- Mother's Day Event Card -->
       <div class="col-lg-6 g-px-25 g-mb-50">
           <article class="u-shadow-v21 g-bg-white g-rounded-5 g-transition-0_3 hover-shadow">
               <div class="row no-gutters">
                   <!-- Image (Left Side) -->
                   <div class="col-md-6">
                       <div class="g-overflow-hidden g-rounded-left-5 h-100">
                           <img
                               class="img-fluid w-100 h-100 g-transform-scale-1_03--hover g-transition-0_3"
                               style="object-fit: cover; min-height: 280px"
                               src="../../../assets/vendor/revolution-slider/revolution/assets/svg/av/Mother's Day CSR.jpeg"
                               alt="NSIA Insurance Mother's Day"
                           />
                       </div>
                   </div>

                   <!-- Text Content (Right Side) -->
                   <div class="col-md-6 g-bg-white g-rounded-right-5">
                       <div class="g-pa-30">
                           <h3 class="h4 g-color-black g-font-weight-600 mb-3">
                               <a
                                   class="u-link-v5 g-color-black g-color-primary--hover"
                                   routerLink="/nsia-insurance-mothers-day-2025"
                               >
                                   NSIA Insurance Celebrates Mother's Day with Support for New Mothers
                               </a>
                           </h3>
                           <p class="g-color-gray-dark-v2 g-font-size-13 mb-3">
                               <i class="fa fa-calendar g-mr-5"></i> 30/03/2025
                           </p>

                           <div
                               class="g-color-gray-dark-v2 g-font-size-15 g-mb-20 text-truncate-container"
                               style="height: 100px; overflow: hidden; position: relative"
                           >
                               <div style="height: 100%">
                                   For NSIA Insurance, Mother's Day 2025 wasn't just about acknowledging the essence of
                                   mothers; it was about showing up and making a real impact. The company marked the
                                   occasion by visiting Ayinke House, the maternity ward at Lagos State University
                                   Teaching Hospital (LASUTH), where essential mother-and-baby care items were donated...
                               </div>
                           </div>

                           <a
                               class="g-brd-main g-brd-primary--hover g-bg-main g-bg-primary--hover text-white u-tags-v1 g-rounded-50 g-py-4 g-px-15"
                               routerLink="/nsia-insurance-mothers-day-2025"
                           >
                               Read more
                           </a>
                       </div>
                   </div>
               </div>
           </article>
       </div>

       <!-- NSIA at 30 Event Card -->
       <div class="col-lg-6 g-px-25 g-mb-50">
           <article class="u-shadow-v21 g-bg-white g-rounded-5 g-transition-0_3 hover-shadow">
               <div class="row no-gutters">
                   <!-- Image (Left Side) -->
                   <div class="col-md-6">
                       <div class="g-overflow-hidden g-rounded-left-5 h-100">
                           <img
                               class="img-fluid w-100 h-100 g-transform-scale-1_03--hover g-transition-0_3"
                               style="object-fit: cover; min-height: 280px"
                               src="../../../assets/vendor/revolution-slider/revolution/assets/svg/av/NSIA @ 30.jpg"
                               alt="NSIA Insurance At 30"
                           />
                       </div>
                   </div>

                   <!-- Text Content (Right Side) -->
                   <div class="col-md-6 g-bg-white g-rounded-right-5">
                       <div class="g-pa-30">
                           <h3 class="h4 g-color-black g-font-weight-600 mb-3">
                               <a class="u-link-v5 g-color-black g-color-primary--hover" routerLink="/nsia-at-30">
                                   30 Years Strong: NSIA Insurance Celebrates a Legacy of Trust
                               </a>
                           </h3>
                           <p class="g-color-gray-dark-v2 g-font-size-13 mb-3">
                               <i class="fa fa-calendar g-mr-5"></i> 17/03/2025
                           </p>

                           <div
                               class="g-color-gray-dark-v2 g-font-size-15 g-mb-20 text-truncate-container"
                               style="height: 100px; overflow: hidden; position: relative"
                           >
                               <div style="height: 100%">
                                   To mark three decades of excellence NSIA Insurance hosted an exclusive celebration
                                   in Lagos, bringing together board members, industry leaders, corporate clients,
                                   brokers, and the media to celebrate this achievement...
                               </div>
                           </div>

                           <a
                               class="g-brd-main g-brd-primary--hover g-bg-main g-bg-primary--hover text-white u-tags-v1 g-rounded-50 g-py-4 g-px-15"
                               routerLink="/nsia-at-30"
                           >
                               Read more
                           </a>
                       </div>
                   </div>
               </div>
           </article>
       </div>

       <!-- LAST TWO EVENTS - Older Style Cards (Modified to Match New Structure) -->
       
       <!-- Women's Month Event Card -->
       <div class="col-lg-6 g-px-25 g-mb-50">
           <article class="u-shadow-v21 g-bg-white g-rounded-5 g-transition-0_3 hover-shadow">
               <div class="row no-gutters">
                   <!-- Image (Left Side) -->
                   <div class="col-md-6">
                       <div class="g-overflow-hidden g-rounded-left-5 h-100">
                           <img
                               class="img-fluid w-100 h-100 g-transform-scale-1_03--hover g-transition-0_3"
                               style="object-fit: cover; min-height: 280px"
                               src="../../../assets/svgs/wm2.svg"
                               alt="Women's Month 2023"
                           />
                       </div>
                   </div>

                   <!-- Text Content (Right Side) -->
                   <div class="col-md-6 g-bg-white g-rounded-right-5">
                       <div class="g-pa-30">
                           <h3 class="h4 g-color-black g-font-weight-600 mb-3">
                               <a
                                   class="u-link-v5 g-color-black g-color-primary--hover"
                                   routerLink="/womens-month-2023"
                               >
                                   Women's Month 2023
                               </a>
                           </h3> <br> 
                           <p class="g-color-gray-dark-v2 g-font-size-13 mb-3">
                               <i class="fa fa-calendar g-mr-5"></i> 01/03/2023
                           </p>

                           <div
                               class="g-color-gray-dark-v2 g-font-size-15 g-mb-20 text-truncate-container"
                               style="height: 100px; overflow: hidden; position: relative"
                           >
                               <div style="height: 100%">
                                   This month of March, we're celebrating in two folds to honour our #NSIAwomen and
                                   women all over the world. First, we will be marking International Women's Day
                                   (Wednesday, March 8) in style, followed by Mother's Day (Sunday, March 19). As
                                   usual, we have a series of activities for you to participate in, and win awesome
                                   prizes!
                               </div>
                           </div>

                           <a
                               class="g-brd-main g-brd-primary--hover g-bg-main g-bg-primary--hover text-white u-tags-v1 g-rounded-50 g-py-4 g-px-15"
                               routerLink="/womens-month-2023"
                           >
                               Read more
                           </a>
                       </div>
                   </div>
               </div>
           </article>
       </div>

       <!-- It's I Time Campaign Event Card -->
       <div class="col-lg-6 g-px-25 g-mb-50">
           <article class="u-shadow-v21 g-bg-white g-rounded-5 g-transition-0_3 hover-shadow">
               <div class="row no-gutters">
                   <!-- Image (Left Side) -->
                   <div class="col-md-6">
                       <div class="g-overflow-hidden g-rounded-left-5 h-100">
                           <img
                               class="img-fluid w-100 h-100 g-transform-scale-1_03--hover g-transition-0_3"
                               style="object-fit: cover; min-height: 280px"
                               src="../../../assets/svgs/slides/roadshow.jpg"
                               alt="NSIA INSURANCE 2023 CAMPAIGN"
                           />
                       </div>
                   </div>

                   <!-- Text Content (Right Side) -->
                   <div class="col-md-6 g-bg-white g-rounded-right-5">
                       <div class="g-pa-30">
                           <h3 class="h4 g-color-black g-font-weight-600 mb-3">
                               <a
                                   class="u-link-v5 g-color-black g-color-primary--hover"
                                   routerLink="/itsitimecampaign"
                               >
                                   NSIA INSURANCE 2023 CAMPAIGN - IT's I TIME
                               </a>
                           </h3>
                           <p class="g-color-gray-dark-v2 g-font-size-13 mb-3">
                               <i class="fa fa-calendar g-mr-5"></i> 08/05/2023
                           </p>

                           <div
                               class="g-color-gray-dark-v2 g-font-size-15 g-mb-20 text-truncate-container"
                               style="height: 100px; overflow: hidden; position: relative"
                           >
                               <div style="height: 100%">
                                   2023 started on a great note with the launch of a new campaign: "It's I Time". The
                                   phrase – It's high time – is most used when something has either become an emergency
                                   of some sort, is unbearable, or is being described as overdue. Simply put, "It's
                                   Insurance Time".
                               </div>
                           </div>

                           <a
                               class="g-brd-main g-brd-primary--hover g-bg-main g-bg-primary--hover text-white u-tags-v1 g-rounded-50 g-py-4 g-px-15"
                               routerLink="/itsitimecampaign"
                           >
                               Read more
                           </a>
                       </div>
                   </div>
               </div>
           </article>
       </div>
   </div>
</div>